import React from 'react';
import NavBarSub from '../layout/NavBarSub';
import SubCareers from '../layout/SubCareers';
import CareersContent from '../layout/CareersContent';
import OurPeople from '../layout/OurPeople';

const Careers = () => {
  return (
    <>
      <NavBarSub />
      <SubCareers />
      <CareersContent />
      <OurPeople />
    </>
  );
};

export default Careers;
